module.exports = __webpack_public_path__ + "static/media/logo.2a3c3ae8.png";